import Tabs from './tabs';
import TabPanel from './tab-panel';
var DefaultTabs = Tabs;
DefaultTabs.Panel = TabPanel;
export default DefaultTabs;
//# sourceMappingURL=index.js.map